module.exports = __webpack_public_path__ + "img/zhuanye.654e8c06.png";